import React, {useEffect, useMemo, useRef, useState} from 'react';
import {Button, Checkbox, DatePicker, Input, List, notification, Radio, Space} from 'antd';
import {CaretDownFilled, DownOutlined, SearchOutlined} from '@ant-design/icons';
import {Link} from 'react-router-dom';
import serviceHelper from '../../../../helpers/functions/service.helper';
import FilterBullet from '../../../../helpers/components/filter_bullet';
import dayjs from 'dayjs';
import MerchantSettlementModal from "./settlement_modal";
import merchantSettlementService from "../../../../services/ewallet_integration/merchant_settlement.service";
import moment from "moment/moment";
import globalHelper from "../../../../helpers/functions/global.helper";
import MerchantSettlementList from "./merchant_settlement_list";
import UserTable from "./user_table";
import UserModal from "./user_modal";
import MerchantService from "../../../../services/ewallet_integration/merchant.service";
import {useSelector} from "react-redux";
import merchantService from "../../../../services/ewallet_integration/merchant.service";

const {RangePicker} = DatePicker;
const MerchantUserLayout = ({merchant = {}}) => {
    const {innerWidth} = window;
    const [settlementModal, setSettlementModal] = useState(false);
    const authRedux = useSelector(state => state?.auth);
    const [refresh, setRefresh] = useState(false);
    const [state, setState] = useState({
        loading: false,
    })
    const [filter, setFilter] = useState({
        search: '',
    })
    const [timer, setTimer] = useState(null);

    const modalRef = useRef();
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [users, setUsers] = useState([]);
    const [editingUser, setEditingUser] = useState(null);
    const [roles, setRoles] = useState([]);

    const doneTyping = async (input) => {
        clearTimeout(timer);
        const newTimer = setTimeout(() => {
            setFilter(filter => ({...filter, search: input,}));
        }, 300);
        setTimer(newTimer);
    }

    const handleDelete = async (userId) => {
        setLoading(true);
        await merchantService.deleteUser(userId, {account_id: authRedux.auth.account_id})
            .then((response) => {
                notification?.success({
                    message : 'User deleted successfully',
                })
                setRefresh(true);
            })
            .catch((error) => {
                notification?.error({
                    message : 'Failed to delete user. Please try again.',
                })
            })
            .finally(() => {
                setLoading(false);
            });
    }
    const EditUser = (user = null) => {
        setIsEdit(true);
        const editUser = {
            id: user.merchant_user_id,
            name: user.name,
            email: user.account?.email,
            role: user.role?.role_id,
        }
        setEditingUser(editUser);
        setIsModalVisible(true);
    };

    const addUser = () => {
        setIsEdit(false);
        setEditingUser(null);
        setIsModalVisible(true);
    }
    const handleCloseModal = () => {
        setIsModalVisible(false);
        setEditingUser(null);
    };

    const handleAddUser = async (value) => {
        setLoading(true);
        const payload = {
            ...value,
            account_id: authRedux.auth.account_id,
        };

        await MerchantService.addUser(merchant?.merchant_id, payload)
            .then((response) => {
                notification?.success({
                    message : 'User added successfully',
                })
                setRefresh(true);
                handleCloseModal();
            })
            .catch((error) => {
                notification?.error({
                    message : 'Failed to add user. Please try again.',
                })
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const handleEditUser = async (value) => {
        setLoading(true);
        const payload = {
            ...value,
            account_id: authRedux.auth.account_id,
        };

        await merchantService.editUser(merchant?.merchant_id, editingUser.id, payload)
            .then((response) => {
                notification?.success({
                    message : 'User updated successfully',
                })
                setRefresh(true);
                handleCloseModal();
            })
            .catch((error) => {
                notification?.error({
                    message : 'Failed to update user. Please try again.',
                })
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const fetchRoleListing = async () => {
        const response = await MerchantService.merchantUserRoleListing();
        if (response) {
            const {data} = response;
            setRoles(data.roles || []);
        }

    };

    useEffect(() => {
        fetchRoleListing();
    }, []);

    return (
        <>
            <div className='mobile-padding-12'>
                <div>
                    {/*<Input*/}
                    {/*    onChange={(e) => doneTyping(e.target.value)}*/}
                    {/*    name="search"*/}
                    {/*    defaultValue={filter?.search}*/}
                    {/*    prefix={<SearchOutlined style={{color: 'var(--secondary-text-color)'}}/>}*/}
                    {/*    placeholder='Search'*/}
                    {/*    style={{minWidth: '100%',}}*/}
                    {/*    allowClear*/}
                    {/*    // {...(errors?.find(x => x?.type === 'search_length') && ({ status : 'warning', }))}*/}
                    {/*/>*/}
                    <div style={{display: 'flex', alignItems: 'center', marginTop: 12, gap: 8,}}>
                        <div className='filter-panel' style={{textAlign: 'start'}}>
                        </div>

                        <div style={{marginLeft: 'auto'}}>
                            <Space>
                                <Button
                                    type="primary"
                                    onClick={() => addUser()}
                                >
                                    Create User
                                </Button>
                            </Space>
                        </div>

                    </div>
                </div>

                <div style={{marginTop: 12,}}>
                    <UserTable
                        merchant={merchant}
                        setRefresh={setRefresh}
                        refresh={refresh}
                        handleDelete={handleDelete}
                        handleEdit={EditUser}
                    />
                </div>
            </div>

            <UserModal
                ref={modalRef}
                visible={isModalVisible}
                onClose={() => setIsModalVisible(false)}
                roles={roles}
                user={editingUser}
                isEdit={isEdit}
                handleAdd={handleAddUser}
                handleDelete={handleDelete}
                handleEdit={handleEditUser}
                authRedux={authRedux}
            />
        </>
    );
}

export default MerchantUserLayout;